// extracted by mini-css-extract-plugin
export default {"form":"styles_form__Za4Hr","remember":"styles_remember__OXdmZ","forgot":"styles_forgot__+sDNZ"};